"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDecoder = exports.addDecoder = void 0;
var registry = new Map();

function addDecoder(cases, importFn) {
  if (!Array.isArray(cases)) {
    cases = [cases]; // eslint-disable-line no-param-reassign
  }

  cases.forEach(function (c) {
    return registry.set(c, importFn);
  });
}

exports.addDecoder = addDecoder;

function getDecoder(_x) {
  return _getDecoder.apply(this, arguments);
}

function _getDecoder() {
  _getDecoder = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fileDirectory) {
    var importFn, Decoder;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            importFn = registry.get(fileDirectory.Compression);

            if (importFn) {
              _context.next = 3;
              break;
            }

            throw new Error("Unknown compression method identifier: ".concat(fileDirectory.Compression));

          case 3:
            _context.next = 5;
            return importFn();

          case 5:
            Decoder = _context.sent;
            return _context.abrupt("return", new Decoder(fileDirectory));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDecoder.apply(this, arguments);
}

exports.getDecoder = getDecoder; // Add default decoders to registry (end-user may override with other implementations)

addDecoder([undefined, 1], function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./raw.js'));
  }).then(function (m) {
    return m.default;
  });
});
addDecoder(5, function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./lzw.js'));
  }).then(function (m) {
    return m.default;
  });
});
addDecoder(6, function () {
  throw new Error('old style JPEG compression is not supported.');
});
addDecoder(7, function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./jpeg.js'));
  }).then(function (m) {
    return m.default;
  });
});
addDecoder([8, 32946], function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./deflate.js'));
  }).then(function (m) {
    return m.default;
  });
});
addDecoder(32773, function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./packbits.js'));
  }).then(function (m) {
    return m.default;
  });
});
addDecoder(34887, function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./lerc.js'));
  }).then(function (m) {
    return m.default;
  });
});
addDecoder(50001, function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./webimage.js'));
  }).then(function (m) {
    return m.default;
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLElBQU1BLFFBQVEsR0FBRyxJQUFJQyxHQUFKLEVBQWpCOztBQUVBLFNBQWdCQyxVQUFoQixDQUEyQkMsS0FBM0IsRUFBa0NDLFFBQWxDLEVBQTBDO0VBQ3hDLElBQUksQ0FBQ0MsS0FBSyxDQUFDQyxPQUFOLENBQWNILEtBQWQsQ0FBTCxFQUEyQjtJQUN6QkEsS0FBSyxHQUFHLENBQUNBLEtBQUQsQ0FBUixDQUR5QixDQUNSO0VBQ2xCOztFQUNEQSxLQUFLLENBQUNJLE9BQU4sQ0FBYyxVQUFDQyxDQUFEO0lBQUEsT0FBT1IsUUFBUSxDQUFDUyxHQUFULENBQWFELENBQWIsRUFBZ0JKLFFBQWhCLENBQVA7RUFBQSxDQUFkO0FBQ0Q7O0FBTERNOztTQU9zQkMsVTs7Ozs7d0ZBQWYsaUJBQTBCQyxhQUExQjtJQUFBO0lBQUE7TUFBQTtRQUFBO1VBQUE7WUFDQ1IsUUFERCxHQUNZSixRQUFRLENBQUNhLEdBQVQsQ0FBYUQsYUFBYSxDQUFDRSxXQUEzQixDQURaOztZQUFBLElBRUFWLFFBRkE7Y0FBQTtjQUFBO1lBQUE7O1lBQUEsTUFHRyxJQUFJVyxLQUFKLGtEQUFvREgsYUFBYSxDQUFDRSxXQUFsRSxFQUhIOztVQUFBO1lBQUE7WUFBQSxPQUtpQlYsUUFBUSxFQUx6Qjs7VUFBQTtZQUtDWSxPQUxEO1lBQUEsaUNBTUUsSUFBSUEsT0FBSixDQUFZSixhQUFaLENBTkY7O1VBQUE7VUFBQTtZQUFBO1FBQUE7TUFBQTtJQUFBO0VBQUEsQzs7OztBQUFQRixnQyxDQVNBOztBQUNBUixVQUFVLENBQUMsQ0FBQ2UsU0FBRCxFQUFZLENBQVosQ0FBRCxFQUFpQjtFQUFBLE9BQU1DO0lBQUEsNEJBQU8sVUFBUDtFQUFBLEdBQW1CQyxJQUFuQixDQUF3QixVQUFDQyxDQUFEO0lBQUEsT0FBT0EsQ0FBQyxDQUFDQyxPQUFUO0VBQUEsQ0FBeEIsQ0FBTjtBQUFBLENBQWpCLENBQVY7QUFDQW5CLFVBQVUsQ0FBQyxDQUFELEVBQUk7RUFBQSxPQUFNZ0I7SUFBQSw0QkFBTyxVQUFQO0VBQUEsR0FBbUJDLElBQW5CLENBQXdCLFVBQUNDLENBQUQ7SUFBQSxPQUFPQSxDQUFDLENBQUNDLE9BQVQ7RUFBQSxDQUF4QixDQUFOO0FBQUEsQ0FBSixDQUFWO0FBQ0FuQixVQUFVLENBQUMsQ0FBRCxFQUFJLFlBQUs7RUFDakIsTUFBTSxJQUFJYSxLQUFKLENBQVUsOENBQVYsQ0FBTjtBQUNELENBRlMsQ0FBVjtBQUdBYixVQUFVLENBQUMsQ0FBRCxFQUFJO0VBQUEsT0FBTWdCO0lBQUEsNEJBQU8sV0FBUDtFQUFBLEdBQW9CQyxJQUFwQixDQUF5QixVQUFDQyxDQUFEO0lBQUEsT0FBT0EsQ0FBQyxDQUFDQyxPQUFUO0VBQUEsQ0FBekIsQ0FBTjtBQUFBLENBQUosQ0FBVjtBQUNBbkIsVUFBVSxDQUFDLENBQUMsQ0FBRCxFQUFJLEtBQUosQ0FBRCxFQUFhO0VBQUEsT0FBTWdCO0lBQUEsNEJBQU8sY0FBUDtFQUFBLEdBQXVCQyxJQUF2QixDQUE0QixVQUFDQyxDQUFEO0lBQUEsT0FBT0EsQ0FBQyxDQUFDQyxPQUFUO0VBQUEsQ0FBNUIsQ0FBTjtBQUFBLENBQWIsQ0FBVjtBQUNBbkIsVUFBVSxDQUFDLEtBQUQsRUFBUTtFQUFBLE9BQU1nQjtJQUFBLDRCQUFPLGVBQVA7RUFBQSxHQUF3QkMsSUFBeEIsQ0FBNkIsVUFBQ0MsQ0FBRDtJQUFBLE9BQU9BLENBQUMsQ0FBQ0MsT0FBVDtFQUFBLENBQTdCLENBQU47QUFBQSxDQUFSLENBQVY7QUFDQW5CLFVBQVUsQ0FBQyxLQUFELEVBQVE7RUFBQSxPQUFNZ0I7SUFBQSw0QkFBTyxXQUFQO0VBQUEsR0FBb0JDLElBQXBCLENBQXlCLFVBQUNDLENBQUQ7SUFBQSxPQUFPQSxDQUFDLENBQUNDLE9BQVQ7RUFBQSxDQUF6QixDQUFOO0FBQUEsQ0FBUixDQUFWO0FBQ0FuQixVQUFVLENBQUMsS0FBRCxFQUFRO0VBQUEsT0FBTWdCO0lBQUEsNEJBQU8sZUFBUDtFQUFBLEdBQXdCQyxJQUF4QixDQUE2QixVQUFDQyxDQUFEO0lBQUEsT0FBT0EsQ0FBQyxDQUFDQyxPQUFUO0VBQUEsQ0FBN0IsQ0FBTjtBQUFBLENBQVIsQ0FBViIsIm5hbWVzIjpbInJlZ2lzdHJ5IiwiTWFwIiwiYWRkRGVjb2RlciIsImNhc2VzIiwiaW1wb3J0Rm4iLCJBcnJheSIsImlzQXJyYXkiLCJmb3JFYWNoIiwiYyIsInNldCIsImV4cG9ydHMiLCJnZXREZWNvZGVyIiwiZmlsZURpcmVjdG9yeSIsImdldCIsIkNvbXByZXNzaW9uIiwiRXJyb3IiLCJEZWNvZGVyIiwidW5kZWZpbmVkIiwiUHJvbWlzZSIsInRoZW4iLCJtIiwiZGVmYXVsdCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9kaXN0LW1vZHVsZS9jb21wcmVzc2lvbi9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==